import { getEnPrioritizedText } from '../utils.js';

function mapOfferingToOfferingSelectionEvent(offering, { isDefaultSelection =false  } = {}) {
    return {
        event: 'RxGlassesConfigEvent',
        eventAction: isDefaultSelection ? 'view step' : 'click on button',
        eventLabel: getEnPrioritizedText(offering.title)
    };
}
function mapOfferingToAddToCartEvent(offering) {
    return {
        event: 'RxGlassesConfigEvent',
        eventAction: 'click on button',
        eventLabel: 'add to cart',
        RxGlasses: {
            productConfig: {
                offering: getEnPrioritizedText(offering.title)
            }
        }
    };
}

export { mapOfferingToAddToCartEvent, mapOfferingToOfferingSelectionEvent };
//# sourceMappingURL=OfferingMapper.js.map
